import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer'
import Layout from '../components/Layout/Layout' 
import NextPrevious from '../components/NextPrevious/NextPrevious'
import config from '../../config'
import { Global } from '@emotion/react'
import { GlobalStyles } from '../GlobalStyles'
import { MainWrapperStyle, TitleStyling,NextPreviousWrapperStyle  } from './docs.css'
import CreativeCommon from '../components/CreativeCommon/CreativeCommon'
import Hint from '../Markdown/mdxComponents/Hint/Hint'

const Docs = (props) => {
  const {
    allMdx,
    mdx,
    site: {
      siteMetadata: { courseCode }
    }
  } = props.data

  //removes gatsbys focus wrapper so that the default click and focus behavior works
  useEffect(() => { 
    const gatsbyFocusWrapper = document.getElementById('gatsby-focus-wrapper') 
    if (gatsbyFocusWrapper) { 
      gatsbyFocusWrapper.removeAttribute('style') 
      gatsbyFocusWrapper.removeAttribute('tabIndex') 
    } 
  }, [])

  const getTitleFromSlug = slug =>
    allMdx.edges.find(({ node }) => node.fields.slug === slug).node.fields.title

  const nav = allMdx.edges
    .map(({ node }) => node.fields.slug)
    .filter(slug => slug !== '/')
    .map(slug => ({ title: getTitleFromSlug(slug), url: slug }))

  // meta tags
  const metaTitle = mdx.frontmatter.metaTitle
  const metaDescription = mdx.frontmatter.metaDescription
  let canonicalUrl = config.gatsby.siteUrl
  canonicalUrl =
    config.gatsby.pathPrefix !== '/'
      ? canonicalUrl + config.gatsby.pathPrefix
      : canonicalUrl
  canonicalUrl = canonicalUrl + mdx.fields.slug

  const isOldMaterial = mdx.fields.slug === '/old' || mdx.fields.slug.startsWith('/old/')

  return (
    <Layout {...props}>
      <Helmet>
        <html lang={config.siteMetadata.language} />
        {metaTitle ? <title>{metaTitle}</title> : <title>{`${courseCode} | ${mdx.fields.title}`}</title>}
        {metaTitle ? <meta name='title' content={metaTitle} /> : <meta name='title' content={`${courseCode} | ${mdx.fields.title}`} />}
        {metaDescription ? (
          <meta name='description' content={metaDescription} />
        ) : null}
        {metaTitle ? <meta property='og:title' content={metaTitle} /> : null}
        {metaDescription ? (
          <meta property='og:description' content={metaDescription} />
        ) : null}
        {metaTitle ? (
          <meta property='twitter:title' content={metaTitle} />
        ) : null}
        {metaDescription ? (
          <meta property='twitter:description' content={metaDescription} />
        ) : null}
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <Global styles={GlobalStyles} /> 

      <div css={TitleStyling} >
        <h1>{mdx.fields.title}</h1>
      </div>
      <div css={MainWrapperStyle(mdx.frontmatter.fullWidth)}>
        {isOldMaterial ? (
          <Hint type='warning'>
            <strong>Det här materialet är inaktuellt.</strong> Det tillhör en
            tidigare kursomgång och gäller inte för 2026. Använd sidorna under
            Föreläsningar 2026 och Laborationer 2026 i stället.
          </Hint>
        ) : null}
        <MDXRenderer>{mdx.body}</MDXRenderer>
      </div>
      <div css={NextPreviousWrapperStyle}>
        <NextPrevious location={props.location} />
      </div>
      <CreativeCommon />
    </Layout>
  )
}

export default Docs

export const pageQuery = graphql`
  query($id: String!) {
    site {
      siteMetadata {
        title
        language
        courseCode
      }
    }
    mdx(fields: { id: { eq: $id } }) {
      fields {
        id
        title
        slug
      }
      body
      tableOfContents
      parent {
        ... on File {
          relativePath
        }
      }
      frontmatter {
        metaTitle
        metaDescription
        fullWidth
      }
    }
    allMdx {
      edges {
        node {
          fields {
            slug
            title
          }
        }
      }
    }
  }
`
